import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { Grid } from "@material-ui/core";
import { toriColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import { disableTori, GetAllTori, changeToriSearch, EditPriceTori } from "Stores/actions";
import cellEditFactory from "react-bootstrap-table2-editor";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Search from "Assets/svg/icon/search.svg";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';

function ToriTable() {
  const { t } = useTranslation();
  const { toriData, toriDataPagination, toriDataSearch, rtlLayout } = useSelector((state) => ({
      toriDataSearch: state.tori.toriDataSearch,
      toriData: state.tori.toriData,
      toriDataPagination: state.tori.toriDataPagination,
      rtlLayout: state.settings.rtlLayout,
    })
  );
  const [sizePerPage, setSizePerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(toriData);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState(null);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (toriData) {
      const isAdmin = read("StypeU") === "1";
      const isRecordRegisteredByAdmin = toriData?.IsG;
      const isUserHasAccessPrice2 = read("toriRules").accessPrice2;
      const updateToriColumn = [...toriColumn];
      const isAllAdmin = toriData.every((item) => item.IsG);
      updateToriColumn[8].hidden = isAdmin || (isUserHasAccessPrice2 === false && isRecordRegisteredByAdmin) || (isAllAdmin && isUserHasAccessPrice2 === false);
      updateToriColumn[2].align = rtlLayout ? "right" : "left";
      updateToriColumn[2].headerAlign= rtlLayout ? "right" : "left";
      setColumns(updateToriColumn);
    }
    return () => setColumns(null);
  }, [toriData]);

  useEffect(() => {
    if (toriData) {
      setTblData(toriData);
      setTotal(toriDataPagination.Total);
      setCurrentPage(toriDataPagination.Page);
      setSizePerPage(toriDataPagination.Limit);
    }
  }, [toriData, toriDataPagination]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        await onGetAllTori(page, sizePerPage);
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const setValue = async (name, value) => {
    setSearch(value);
  }

  const onSearch = async (e) => {
    e.preventDefault();
    setCurrentPage(1);
    await onGetAllTori(1, sizePerPage, search);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearch("");
    setCurrentPage(1);
    await onGetAllTori(1, sizePerPage, "");
  }

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    newValue = convertToEnglishNumber(newValue) < 0 
      ? (-1 * convertToEnglishNumber(newValue)) 
      : convertToEnglishNumber(newValue);
    if (column.dataField === "Disable") {
      const updateNewValue = JSON.parse(newValue);
      if (oldValue !== updateNewValue) {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: +row.Id,
            Disable: updateNewValue,
          };
          await dispatch(disableTori(data));
          await onGetAllTori();
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        done(false);
      }
    }
    if (column.dataField === "GroupPrice" || column.dataField === "UserPrice") {
      const newPrice = isNaN(newValue) ? newValue.replaceAll(",", "") : newValue;
      const oldPrice = oldValue.replaceAll(",", "");
      if (parseFloat(newPrice) !== parseFloat(oldPrice)) {
        try {
          setLoading(true);
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Price: +newPrice,
            IdNet: row.Id,
          };
          await dispatch(EditPriceTori(data));
          await onGetAllTori();
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        done(false);
      }
    }
  }

  const onGetAllTori = async (Page = currentPage, Limit = sizePerPage, data = 'NODATA') => {
    setLoading(true);
    try{
      let dataSearch = null;
      if(data !== 'NODATA') {if(data !== '') dataSearch = { Name: convertToEnglishNumber(data) }}
      else if(search !== '') dataSearch = { Name: convertToEnglishNumber(search) }
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        Limit,
        Page,
        ...dataSearch,
      };
      await dispatch(GetAllTori(params));
    } catch (err) { console.log('[onGetPriceAction]', err) }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
        <Grid container spacing={2} className="mb-1">
          <Grid item lg={3} md={4} sm={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={search}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {columns && (
        <RemoteTable
          data={tblData}
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          title={<Translator id="list_tori" />}
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
          })}
        />
      )}
    </Fragment>
  );
}

export default ToriTable;
